(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["manual-lists"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const items = document.querySelectorAll('.accordion-manual .file-lists__item');

  items.forEach(item => {
    const content = item.querySelector('.file-lists__itemContent');

    // Optional: start closed
    content.classList.add('active');

  });
});

  } catch(e) { console.error(e); }
})();
})();
